import './styles/app.css';
import Header from './layouts/Header';
import { Outlet } from 'react-router-dom';
import TopBar from './layouts/TopBar';
import Footer from './layouts/Footer';
import { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import AxiosAuth from './api/AxiosAuth';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from './redux';
import { ProfileStudent, StudentType } from './Utils/DataType';
import { setAuth } from './redux/AuthSlice';
import Loading from './components/Loading';
import { setProfle } from './redux/ProfileSlice';
import AxiosClient from './api/AxiosClient';

function App() {
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    setIsLoad(true);
    AxiosAuth.get('profile').then((data) => {
      let profile = data?.data;
      if (profile && profile.id) {

        dispatch(setAuth(true));
        AxiosClient.get(`students/${profile.id}`).then((student) => {
          let st: ProfileStudent = student.data.data;
          dispatch(setProfle(st))
        }).finally(() => setIsLoad(false));

      } else setIsLoad(false);
    }).catch((e) => {
      setIsLoad(false);
    })
  }, [])

  return (
    <div className="app">
      <ToastContainer />
      {!isLoad && (
        <>
          <TopBar />
          <Header />
          <Outlet />
          <Footer /></>
      )}
      {isLoad && <div className='h-screen w-full flex items-center justify-center bg-white'><Loading /></div>}
    </div>
  );
}

export default App;
